import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON, isOk, authReq} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/



/******************************
*******  Asynchronous  ********
******************************/

export function usersInviteRequest(inviteData) {

	return dispatch => {
		let url = api.URL + endpoint.USERS_INVITE;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(inviteData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function usersContactRequest(contactData) {
	return dispatch => {
		let url = api.URL + endpoint.USERS_CONTACT;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(contactData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}



// WEBPACK FOOTER //
// ./src/actions/users.jsx